// extracted by mini-css-extract-plugin
module.exports = {"userButton":"top_nav_userButton__tI1RY","searchIcon":"top_nav_searchIcon__cA_7_","searchBar":"top_nav_searchBar__48iCQ"};